module.exports = __webpack_public_path__ + "media/ab-homepage/mobile-share-5bbc6fd9.png";